import axios from 'axios';

export const CompletedRequestsApi = {
  getRequests: filter => axios.get(
    `/api/public/info/paging/request_form/requester?filter=${JSON.stringify(filter)}`
  )
};